import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui'
import { useGetEcommerceCompletitionStatusQuery } from '@/feature/financial-model/api'
import { Skeleton } from '@/components/ui/skeleton.tsx'
import { useDebugModeStore } from '@/global/store'

export const FinancialTablesLink = ({ financialModelId }: { financialModelId: string }) => {
  const { t } = useTranslation(`financialModel`)
  const { data } = useGetEcommerceCompletitionStatusQuery(financialModelId)

  const debugMode = useDebugModeStore(state => state.mode)

  if (!data) {
    return <Skeleton className='h-6 w-24' />
  }
  const isDisabled = String(data.cogs.status) !== `100` || String(data.revenue.status) !== `100`
  return (
    <Link
      to={`/dashboard/financial-model/${financialModelId}/ecommerce/financial-tables`}
      aria-disabled={debugMode === `test` ? false : isDisabled}
      className={isDisabled ? `aria-disabled:pointer-events-none aria-disabled:cursor-not-allowed` : ``}
    >
      <Button variant='outline' size='md' disabled={debugMode ? false : isDisabled}>
        {t(`financial_model.library.home.financial_tables`)}
      </Button>
    </Link>
  )
}
